export default {
  data() {
    return {
      qcReports: [
        {
          title: 'نظرسنجی مردمی',
          id: 1,
          icon: 'mdi-clipboard-text ',
          icon2: 'mdi-clipboard-text mdi-36px',
          background: 'background:#00305A',
          background2: 'background:#1F496E',
        },
        {
          title: 'گزارش سفارشی',
          id: 12,
          icon: 'mdi-book',
          icon2: 'mdi-book mdi-36px',
          background: 'background:#0067A6',
          background2: 'background:#1F79B1',
        },
        {
          title: 'کاربران آنلاین',
          id: 2,
          icon: 'mdi-account-multiple ',
          icon2: 'mdi-account-multiple mdi-36px',
          background: 'background:#0092B2',
          background2: 'background:#1F9FBB',
        },
        {
          title: 'گزارش پرونده ها (بایگانی)',
          id: 3,
          icon: 'mdi-file-document ',
          icon2: 'mdi-file-document mdi-36px',
          background: 'background:#04BFBF',
          background2: 'background:#22C7C7',
        },
        {
          title: 'گزارش زمان ها',
          id: 13,
          icon: 'mdi-timer',
          icon2: 'mdi-timer mdi-36px',
          background: 'background:#00bbe6',
          background2: 'background:#007d99',
        },
        {
          title: 'ورود و خروج کاربر',
          id: 4,
          icon: 'mdi-account-arrow-right ',
          icon2: 'mdi-account-arrow-right mdi-36px',
          background: 'background:#4C1273',
          background2: 'background:#602E83',
        },
        {
          title: 'گزارش تماس ها',
          id: 5,
          icon: 'mdi-phone ',
          icon2: 'mdi-phone mdi-36px',
          background: 'background:#512DA8',
          background2: 'background:#6646B2',
        },
        {
          title: 'کارکرد کاربران',
          id: 6,
          icon: 'mdi-file-document ',
          icon2: 'mdi-file-document mdi-36px',
          background: 'background:#7B1FA2',
          background2: 'background:#8B3AAD',
        },
        // {
        //   title: "تماس های کاربران اداره ارتباطات، هماهنگی و پایش عملیات",
        //   id: 7,
        //   icon: "mdi-phone ",
        //   icon2: "mdi-phone mdi-36px",
        //   background: "background:#AB47BC",
        //   background2: "background:#B55DC4",
        // },
        {
          title: 'زمان های ماموریت',
          id: 8,
          icon: 'mdi-clock-time-four ',
          icon2: 'mdi-clock-time-four mdi-36px',
          background: 'background:#04756F',
          background2: 'background:#2A898B',
        },
        {
          title: 'عملکرد تکنسین ها',
          id: 9,
          icon: 'mdi-account',
          icon2: 'mdi-account mdi-36px',
          background: 'background:#168039',
          background2: 'background:#399260',
        },
        {
          title: 'زمان های فنس',
          id: 10,
          icon: 'mdi-map-clock ',
          icon2: 'mdi-map-clock mdi-36px',
          background: 'background:#45BF55',
          background2: 'background:#5EC577',
        },
        {
          title: 'گزارش تحویل و تحول',
          id: 11,
          icon: 'mdi-swap-horizontal ',
          icon2: 'mdi-swap-horizontal mdi-36px',
          background: 'background:#8BC34A',
          background2: 'background:#96C86E',
        },
        {
          title: 'مدت زمان DND',
          id: 12,
          icon: 'mdi-shield-account-variant',
          icon2: 'mdi-shield-account-variant mdi-36px',
          background: 'background:#FF6138',
          background2: 'background:#F37A60',
        },
      ],
      searchTitle: '',
    };
  },
  methods: {
    goToReport: function (title) {
      if (title == 'نظرسنجی مردمی') {
        this.$router.push({ name: 'qcSurveyReport' });
      } else if (title == 'کاربران آنلاین') {
        this.$router.push({ name: 'qcOnlineUsersReport' });
      } else if (title == 'گزارش پرونده ها (بایگانی)') {
        this.$router.push({ name: 'missionReport' });
      } else if (title === 'گزارش زمان ها') {
        this.$router.push({ name: 'average-times-report' });
      } else if (title == 'ورود و خروج کاربر') {
        this.$router.push({ name: 'qcUsersLoginLogoutReport' });
      } else if (title == 'گزارش تماس ها') {
        this.$router.push({ name: 'qcCallsReport' });
      } else if (title == 'کارکرد کاربران') {
        this.$router.push({ name: 'qcUsersForQCReport' });
      } else if (title == 'تماس های کاربران اداره ارتباطات، هماهنگی و پایش عملیات') {
        console.log('not found');
      } else if (title == 'زمان های ماموریت') {
        this.$router.push({ name: 'qcMissionTimesReport' });
      } else if (title == 'عملکرد تکنسین ها') {
        this.$router.push({ name: 'qcTechnicianPerformanceReport' });
      } else if (title == 'زمان های فنس') {
        this.$router.push({ name: 'qcMissionFenceTimesReport' });
      } else if (title == 'گزارش تحویل و تحول') {
        this.$router.push({ name: 'qcCheckListReport' });
      } else if (title == 'گزارش سفارشی') {
        this.$router.push({ name: 'QcCustomReport' });
      } else if (title == 'مدت زمان DND') {
        this.$router.push({ name: 'qcDNDTimesReport' });
      }
    },
  },
};
